import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql, Link } from 'gatsby';
import Img from 'gatsby-image';

import Wrapper from '../../elements/wrapper';
import { media } from '../../helpers';
import Wave from '../../../images/waves/home-top-wave.inline.svg';

const HomeInstagramContainer = styled.div`
    padding: 0 0 5vh;
    background-color: #f2f0eb;
    ${media.small`margin: 0 0 10vh;`}
    ${media.medium`margin: 15vh 0 0; padding: 0 0 15vh;`}
    ${media.laptop`padding: 0 0 10vh; margin-top: 5vh;`}

    .svg-container {
        background-color: #f2f0eb;

        svg {
            width: 100%;
            height: auto;
            path {
                opacity: 1;
                fill: #fff;
            }
        }
    }
    .title-container {
        text-align: center;
        padding: 40px 0 0;
        h3 {
            margin: 0;
            font-size: 1.5rem;
            color: #000;
            font-weight: 800;
            font-family: neue-kabel, sans-serif;
        }
    }
    .images-container {
        display: flex;
        flex-wrap: wrap;
        padding-top: 60px;
        ${media.medium`max-width: 82.5vw;`}

        .item-container {
            flex: 1 1 50%;
            margin-bottom: 10px;
            ${media.medium`flex: 1;`}

            > .inner-wrap {
                max-width: 95%;
                margin: 0 auto;
            }
        }
    }
`;

const HomeInstagram = () => {
    const data = useStaticQuery(graphql`
        query {
            home: allWpPage(filter: { title: { eq: "Home" } }) {
                edges {
                    node {
                        home_acf {
                            instagramRowSettings {
                                instagramTitle
                                instagramImages {
                                    image {
                                        localFile {
                                            childImageSharp {
                                                fluid(maxWidth: 600) {
                                                    ...GatsbyImageSharpFluid
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);
    const { instagramTitle, instagramImages } =
        (data && data.home.edges[0].node.home_acf.instagramRowSettings) || {};
    return (
        <HomeInstagramContainer>
            <div className="svg-container">
                <Wave />
            </div>

            <Wrapper className="images-container">
                {instagramImages &&
                    instagramImages.map((imageNode) => {
                        let { image } = imageNode || {};
                        return (
                            <div className="item-container">
                                <div className="inner-wrap">
                                    <div className="image-container">
                                        <Img
                                            fluid={
                                                image.localFile.childImageSharp
                                                    .fluid
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </Wrapper>
            <Wrapper className="title-container">
                <h3>{instagramTitle}</h3>
            </Wrapper>
        </HomeInstagramContainer>
    );
};

export default HomeInstagram;
